/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ServiceEventTicketDto
 */
export interface ServiceEventTicketDto {
    /**
     *
     * @type {number}
     * @memberof ServiceEventTicketDto
     */
    serviceEventTicketId?: number;
    /**
     *
     * @type {number}
     * @memberof ServiceEventTicketDto
     */
    serviceEventId?: number;
    /**
     *
     * @type {string}
     * @memberof ServiceEventTicketDto
     */
    ticketId?: string;
}

/**
 * Check if a given object implements the ServiceEventTicketDto interface.
 */
export function instanceOfServiceEventTicketDto(
    value: object,
): value is ServiceEventTicketDto {
    return true;
}

export function ServiceEventTicketDtoFromJSON(
    json: any,
): ServiceEventTicketDto {
    return ServiceEventTicketDtoFromJSONTyped(json, false);
}

export function ServiceEventTicketDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ServiceEventTicketDto {
    if (json == null) {
        return json;
    }
    return {
        serviceEventTicketId:
            json["serviceEventTicketId"] == null
                ? undefined
                : json["serviceEventTicketId"],
        serviceEventId:
            json["serviceEventId"] == null ? undefined : json["serviceEventId"],
        ticketId: json["ticketId"] == null ? undefined : json["ticketId"],
    };
}

export function ServiceEventTicketDtoToJSON(
    value?: ServiceEventTicketDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        serviceEventTicketId: value["serviceEventTicketId"],
        serviceEventId: value["serviceEventId"],
        ticketId: value["ticketId"],
    };
}
